import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  contentWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    width: '100%',
    marginBottom: theme.spacing(4)
  },
  ufcImage: {
    width: 80,
    height: 'auto',
    objectFit: 'contain',
    marginTop: theme.spacing(3)
  },
  contentContainer: {
    width: '100%'
  },
  paragraph: {
    marginBottom: theme.spacing(4),
    fontSize: '1rem',
    lineHeight: 1.8,
    color: theme.palette.text.primary
  },
  locationParagraph: {
    fontSize: '1rem',
    lineHeight: 1.8,
    color: theme.palette.text.primary
  }
}))
